export enum ApiErrorCode {
    OoeInvalidDataFormat = 2006,
    OperationNotSupported = 5000,
    AttachmentSizeExceeded = 9000,
    NumberOfAttachmentsExceeded = 9001,
    InvalidAttachmentId = 9003,
    InvalidAttachmentPath = 9004,
    CannotAddAttachmentBeforeUpgrade = 9005,
    AttachmentDeletedBeforeUploadCompletes = 9006,
    AttachmentUploadGeneralFailure = 9007,
    AttachmentToDeleteDoesNotExist = 9008,
    AttachmentDeleteGeneralFailure = 9009,
    InvalidEndTime = 9010,
    HtmlSanitizationFailure = 9011,
    NumberOfRecipientsExceeded = 9012,
    CursorPositionChanged = 9014,
    ComposeFormNotReadyForAttachments = 9015,
    InvalidSelection = 9016,
    GenericTokenError = 9018,
    GenericSettingsError = 9019,
    GenericResponseError = 9020,
    SaveError = 9021,
    DuplicateNotificationKey = 9023,
    NotificationKeyNotFound = 9024,
    NumberOfNotificationsExceeded = 9025,
    PersistedNotificationArrayReadError = 9026,
    PersistedNotificationArraySaveError = 9027,
    CannotPersistPropertyInUnsavedDraftError = 9028,
    CallSaveAsyncBeforeToken = 9029,
    InvalidParameterValueError = 9031,
    ApiCallNotSupportedByExtensionPoint = 9032,
    SetRecurrenceOnInstance = 9033,
    InvalidRecurrence = 9034,
    InsufficientItemPermissions = 9038,
    InternalServerError = 9042,
    AttachmentTypeNotSupported = 9043,
    InvalidCategoryError = 9044,
    DuplicateCategoryError = 9045,
    ItemNotSavedError = 9046,
    MissingExtendedPermissionsForAPIError = 9047,
    ItemNotFound = 9049,
    KeyNotFound = 9050, //When the specified key isn't found
    SessionDataObjectMaxLengthExceeded = 9051, //when all key + pair values exceeds the given limit
}

export default ApiErrorCode;
